import PropTypes from 'prop-types';
import styles from './FJNavBar.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJToolTip from '../FJToolTip/FJToolTip.jsx';
import React from 'react';

const FJNavBar = props => {
    const { selectTab, onChangeTab, tabList, style, isMusicNav, hasTooltip } = props;
    return (
        <ul className={classNames(styles.container, isMusicNav && styles.music_nav)} style={style}>
            {tabList.map(tab => (
                <React.Fragment key={tab.value}>
                    {hasTooltip ? (
                        <FJToolTip title={tab.name}>
                            <li
                                className={classNames(styles.item, {
                                    [styles.active]: selectTab === tab.value,
                                })}
                                onClick={() => onChangeTab(tab.value)}
                            >
                                <tab.icon />
                            </li>
                        </FJToolTip>
                    ) : (
                        <li
                            className={classNames(styles.item, {
                                [styles.active]: selectTab === tab.value,
                            })}
                            onClick={() => onChangeTab(tab.value)}
                        >
                            <tab.icon />
                            <span className={styles.name}>{FJLocalStore._(tab.name)}</span>
                        </li>
                    )}
                </React.Fragment>
            ))}
        </ul>
    );
};

FJNavBar.propTypes = {
    selectTab: PropTypes.string,
    onChangeTab: PropTypes.func,
    tabList: PropTypes.array,
    style: PropTypes.object,
    isMusicNav: PropTypes.bool,
    hasTooltip: PropTypes.bool,
};

export default FJNavBar;
